import React from 'react';
import { render } from '@testing-library/react';
import { ColorPicker } from './ColorPicker';

describe('ColorPicker', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<ColorPicker
				colors={[
					'#1fbc70',
					'#ff745f',
					'#faafe2',
					'#8772e5',
					'#01f346',
					'#90efc0',
					'#ffcc80',
					'rgb(8, 191, 223)',
					'rgb(204, 157, 127)',
				]}
				value="#ff745f"
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
